export function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) { timeoutInMs = 0; }
    return new Promise(function (resolve, reject) {
        if (timeoutInMs) {
            setTimeout(function () {
                var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
                timeoutError.name = "TimeoutError";
                reject(timeoutError);
            }, timeoutInMs);
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/fetch-http-handler/dist-es/request-timeout.js
// module id = 743
// module chunks = 0